import { css } from "styled-components";

export const TypographyStyles = css(
    ({ theme }) => css`
        .Typography.Light {
            opacity: 1;
            color: ${theme.palette.lightText};
        }
    `,
);
